var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.clicked)?_c('div',{staticClass:"loaders"}):_vm._e(),_c('button',{on:{"click":function($event){return _vm.change('loader', 'loaders')}}},[_vm._v("Change")])])}
var staticRenderFns = []

export { render, staticRenderFns }